import { Box, Button, Container, Stack, Typography } from '@mui/material'

import ChooseUsBanner from '../landingPage/chooseUsBanner';
import DiscountBanner from '../landingPage/discountBanner';
import FooterSection from '../footerSection';
import Navbar from 'src/components/navbar/navbar';
import React from 'react'
import ServiceCard from 'src/components/serviceCard';
import Testimonials from '../landingPage/testimonials';
import TypingEffect from 'src/components/typingEffect';
import backgroundImage from "../../resources/images/hero_img_bg.jpg";
import bannerBgImage from "../../resources/images/img_3.jpg"
import { content } from 'src/common/lang/en-US';
import { motion } from 'framer-motion';
import { servicesData } from 'src/resources/data/landingPageData';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';

const AllServices: React.FC = () => {
  const { title } = content.servicesPage.ourServices;
  const { heading, headingContent } = content.servicesPage;

  const navigate = useNavigate();

  const { ref: buttonRef, inView: buttonInView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <Box sx={{ position: 'relative', overflowX: 'hidden' }}>
      {/* Hero Section */}
      <Box sx={{ position: 'relative', height: '100vh' }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: "column",
            alignItems: 'center',
            color: '#fff',
            textAlign: 'center',
            background: 'rgba(0, 0, 0, 0.3)',
          }}
        >
          <Navbar />
          <Container sx={{ mt: 12 }}>
            <Stack direction="row" justifyContent="center">
              <Typography width={{ xs: "80%", sm: "80%", md: "50%", lg: "50%" }} variant="h1_Thin" component="h1" gutterBottom>
                {heading}{"\u00A0"}
                <TypingEffect
                  words={headingContent}
                  typographySX={{
                    color: '#ea728c',
                    fontSize: '4rem',
                  }}
                  varient="h1_Thin"
                />
              </Typography>
            </Stack>
            <Stack ref={buttonRef} justifyContent="center" direction="row" width="100%">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={buttonInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8 }}
              >
                <Button
                  sx={{
                    backgroundColor: '#ea728c',
                    color: '#FFFFFF',
                    borderRadius: '30px',
                    px: '30px',
                    py: '18px',
                    mt: 4,
                    fontSize: '14px',
                    width: '10rem',
                  }}
                >
                  Get Started
                </Button>
              </motion.div>
            </Stack>
          </Container>
        </Box>
      </Box>
      <Box sx={{ py: 10, px: { xs: 4, sm: 10 }, backgroundColor: '#fafafa', zIndex: 2, position: 'relative' }}>
        <Box py={4}>
          <Stack direction="row" justifyContent="center">
            <Stack direction="column" alignItems="center" gap={4}>
              <Typography variant='subtitle1' fontWeight={500}>{title}</Typography>
              <Box border="1px solid red" width="8rem" />
            </Stack>
          </Stack>

          {/* <Box p="3.2rem" bgcolor="#fff" width="100%"> */}
          <Box
            pt={8}
            display="grid"
            gap={4}
            width="100%"
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(3, 1fr)'
            }}
          >
            {servicesData(false).map((service, index) => (
              <ServiceCard
                subTitle={service.subTitle}
                onClick={() => service.link && navigate(`/${service.link}`)}
                key={index}
                image={service.image}
                title={service.title}
                description={service.description}
                buttonName={service.buttonName}
              />
            ))}
          </Box>
          {/* </Box> */}
        </Box>
      </Box>

      {/* Why choose us section component */}
      <ChooseUsBanner />

      {/* Customer Reviews */}
      <Testimonials />

      {/* discount banner component */}
      <Box
        sx={{
          position: 'relative',
          height: '60vh',
          backgroundImage: `url(${bannerBgImage})`,
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(234, 114, 140, 0.9)',
            zIndex: 1,
          }}
        />
        <Box sx={{ position: 'relative', zIndex: 2 }}>
          <DiscountBanner />
        </Box>
      </Box>

      <FooterSection />
    </Box>
  )
}
export default AllServices